import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineShoppingCart,
  AiOutlineUser,
  AiOutlineBgColors,AiOutlineLogout
} from "react-icons/ai";
import { RiCouponLine } from "react-icons/ri";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { ImBlog } from "react-icons/im";
import { IoIosNotifications } from "react-icons/io";
import { FaClipboardList, FaBloggerB } from "react-icons/fa";
 
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
 import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
 
 import { MdQuestionAnswer } from "react-icons/md";
import { getEnquiries } from "../features/enquiry/enquirySlice";
 import { FaChalkboardTeacher } from "react-icons/fa";
 import { FaClipboard } from "react-icons/fa";
 import { SlCalender } from "react-icons/sl";
 import { MdEvent } from "react-icons/md";
 import { MdOutlineEventNote } from "react-icons/md"; 
 import { BiSolidCalendarEvent } from "react-icons/bi";
import { getCourseRequests } from "../features/courseRequests/courseRequestSlice";
import { getBookings } from "../features/booking/bookingSlice";



const { Header, Sider, Content } = Layout;


const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    dispatch(getEnquiries());
    dispatch(getBookings());
    dispatch(getCourseRequests());
  
    const interval = setInterval(() => {
      dispatch(getEnquiries());
      dispatch(getBookings());
      dispatch(getCourseRequests());
    }, 1000);
  
    return () => clearInterval(interval);
  }, [dispatch]);
  
  
  // Fetch unread orders count from the Redux store
   const unreadEnquiriesCount = useSelector(state => state?.enquiry?.enquiries?.filter(e => !e.read)?.length || 0);
   const unreadCourseRequestsCount = useSelector(state => state?.courseRequests?.courseRequests?.filter(e => !e.read)?.length || 0);
   const unreadBookingsCount = useSelector(state => state?.booking?.bookings?.filter(e => !e.read)?.length || 0);

  // Calculate the total unread count
  const totalUnreadCount =unreadBookingsCount + unreadCourseRequestsCount + unreadEnquiriesCount;
   const {
    token: { colorBgContainer },
  } = theme.useToken();

 
 
 

  
  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">Q.T.L</span>
            <span className="lg-logo">Qentrain Solutions</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          className="menu-wrapper"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              localStorage.clear()
              window.location.reload()
            } else {
              navigate(key);
            }
          }}
          items={[


            
            {
              key: "Course",
              icon: <FaChalkboardTeacher className="fs-4" />,
              label: "Courses",
              children: [
                {
                  key: "course",
                  icon: <FaClipboard className="fs-4" />,
                  label: "Add Course",
                },
                {
                  key: "course-list",
                  icon: <FaClipboardList className="fs-4" />,
                  label: "Course List",
                },
         
              ],
            },
               
            {
              key: "Event",
              icon: <MdEvent className="fs-4" />,
              label: "Events",
              children: [
                {
                  key: "event",
                  icon: <MdEvent className="fs-4" />,
                  label: "Add Event",
                },
                {
                  key: "event-list",
                  icon: <MdOutlineEventNote className="fs-4" />,
                  label: "Event List",
                },
         
              ],
            },


     
             {
                 key: "blogs",
                 icon: <FaBloggerB className="fs-4" />,
                 label: "Blogs",
                 children: [
                   {
                     key: "blog",
                     icon: <ImBlog className="fs-4" />,
                     label: "Add Blog",
                   },
                   {
                     key: "blog-list",
                     icon: <FaBloggerB className="fs-4" />,
                     label: "Blog List",
                   },
            
                 ],
               },
 
  
               {
                key: "bookings",
                icon: 
                (
                  <div className="position-relative">
                  <BiSolidCalendarEvent className="fs-4" />
                  {unreadBookingsCount > 0 && (
                 <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>

                  )}
                  </div>
                ),

                label: "Event Bookings",
              },
              {
                key: "course-requests",
                icon:(
                 <div className="position-relative">
                 <FaChalkboardTeacher className="fs-4" />,

                  {unreadCourseRequestsCount > 0 && (
                <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>
   
                  )}
                 </div>
                ), 
                
                label: "Course Requests",
              },
            {
              key: "enquiries",
              icon: (
                <div className="position-relative">
                  <MdQuestionAnswer className="fs-4" />
                  {unreadEnquiriesCount > 0 && (
                    <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>
                  )}
                </div>
              ),
              label: "Enquiries",
            },
    
            {
              key: "signout",
              icon: <AiOutlineLogout className="fs-4" />,
              label: "Sign Out",
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
          <div className="position-relative"  >
          <IoIosNotifications className="fs-4" />
          {totalUnreadCount > 0 && (
        <span className="badge bg-warning rounded-circle p-1 position-absolute" style={{ zIndex: 1 }}>
          {totalUnreadCount}
        </span>
      )}
             </div>

            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
           
              </div>
         
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
